/** @format */
import Cookies from "js-cookie";

export async function getInstance(token, modelId = null) {
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/process/list/full`;

  // Créer un objet body avec ModelId uniquement s'il est fourni
  const body = modelId ? { ModelId: modelId } : {};
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body), 
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
